import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close } from "@mui/icons-material";

export default function AcceptDialog({
  onClose,
  onAccept,
  loading,
}) {
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            Aceitar Ação
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption">
          Ja existe um arquivo para omesmo período. Deseja substituir o arquivo existente?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            onClose();
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAccept}
          disabled={loading}
        >
          Substituir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
